import { Game } from "../../../domain/model/Game";
import { Player } from "../../../domain/model/User";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { PlayerRepository } from "./PlayerRepository";

export class PlayerRepositoryImpl implements PlayerRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  getCurrentUserInfo(): Promise<Response<Player>> {
    return this.apiService.getCurrentUserInfo();
  }
  getPlayerUnfinishedGames(
    skip: number,
    limit: number,
  ): Promise<Response<Array<Game>>> {
    return this.apiService.getPlayerUnfinishedGames(skip, limit);
  }
}
